module.exports = __webpack_public_path__ + "media/images/faces/male/39-91beb601d92f566cf79671824d8e233e.jpg";